<template>
  <VCard class="elevation-12">
    <VToolbar
      dark
      color="primary"
    >
      <VToolbarTitle>Phone Verification</VToolbarTitle>
    </VToolbar>
    <VCardText>
      <VForm
        ref="requestForm"
        v-model="requestForm"
        @submit="handleRequest"
      >
        <VTextField
          v-model="phoneNumber"
          :mask="phoneMask"
          :rules="phoneNumberRules"
          prepend-icon="phone"
          name="phonenumber"
          label="Phone Number"
          type="text"
        />
        <VCardActions>
          <VSpacer />
          <VBtn
            :loading="loading"
            :disabled="!requestForm"
            color="primary"
            type="submit"
            @click.prevent="handleRequest"
          >
            Send
          </VBtn>
        </VCardActions>
      </VForm>
    </VCardText>
    <NetworkSnackBar />
  </VCard>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NetworkSnackBar from './NetworkSnackBar'
export default {
  name: 'PhoneVerificationRequestCard',
  components: { NetworkSnackBar },
  data: () => ({
    requestForm: false,
    countryCode: 1,
    snackBarTimeout: 6000,
    phoneMask: 'phone',
    phoneNumberRules: [
      v => !!v || 'Required.',
      v => /^\d{10}$/.test(v) || 'Phone number must be valid'
    ]
  }),
  computed: {
    phoneNumber: {
      get: function () {
        return this.getRequestPhoneNumber
      },
      set: function (val) {
        this.setRequestPhoneNumber({ val })
      }
    },
    ...mapGetters({
      loading: 'account/getRequestPhoneVerificationLoading',
      getRequestPhoneNumber: 'account/getRequestPhoneNumber'
    })
  },
  methods: {
    handleRequest () {
      const { dispatch } = this.$store
      const { phoneNumber } = this
      if (this.$refs.requestForm.validate()) {
        dispatch('alert/clear')
          .then(() => dispatch('account/requestPhoneVerification', { phoneNumber }))
      }
    },
    ...mapActions({
      setRequestPhoneNumber: 'account/setRequestPhoneNumber'
    })
  }
}
</script>

<style scoped>

</style>
